import styled from 'styled-components'

export const TooltipWrapperUi = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`
